import React, { useEffect, useState } from "react";
import { StyledBlueButton } from "../../styles/BootstrapStyles";
import { Form, Col } from "react-bootstrap";
import { ASSET_TYPE } from "../../constants/ContentFinder";
import "../../styles/media-search.scss";
import "../../styles/contentFinder.scss";

const ContentFinderSearch = ({
  value,
  placeholder,
  onChange,
  onSearch,
  recordType,
}) => {
  const [error, setError] = useState("");

  const isIdSearch =
    recordType === ASSET_TYPE.ID;

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const trimmedValue = value.trim();

    // prevent search when invalid
    if (isIdSearch && error) {
      setError("Please enter a valid ID");
      return;
    }

    // prevent empty search
    if (!trimmedValue) {
      return;
    }

    onSearch();
  };

  const getErrorMessage = () => {
    return "Please enter a valid ID";
  };

  useEffect(() => {
    if (!isIdSearch) {
      setError("");
      return;
    }

    const trimmedValue = value.trim();

    if (!trimmedValue) {
      setError("");
      return;
    }

    /**
     * Rules:
     * - only one ID
     * - no commas/semicolon/newlines
     * - no spaces between values
     * - no special characters
     */

    const hasSeparators =
      /[,;\n]/.test(trimmedValue);

    const hasMultipleWords =
      trimmedValue.split(/\s+/).length > 1;

    const hasSpecialCharacters =
      /[^a-zA-Z0-9_-]/.test(trimmedValue);

    if (
      hasSeparators ||
      hasMultipleWords ||
      hasSpecialCharacters
    ) {
      setError("INVALID");
      return;
    }

    setError("");
  }, [value, isIdSearch]);

  return (
    <Form
      onSubmit={handleSubmit}
      className="search-by-ids-form"
    >
      <Form.Group
        className={`media-search-textarea-group ${recordType === ASSET_TYPE.TITLE ? 
          "content-finder-search-group" : ""}`}
        as={Col}
        controlId="contentFinderSearch"
      >
        <Form.Control
          placeholder={placeholder}
          autoComplete="off"
          required
          value={value}
          isInvalid={isIdSearch && !!error}
          onChange={(e) =>
            onChange(e.target.value.trimStart())
          }
        />

        <Form.Control.Feedback type="invalid">
          {getErrorMessage()}
        </Form.Control.Feedback>
      </Form.Group>

      <StyledBlueButton
        type="submit"
        className="media-search-by-id-button"
      >
        Search
      </StyledBlueButton>
    </Form>
  );
};

export default ContentFinderSearch;
